import React, { useState } from "react";
import Contacts from "@/pages/contacts";
import Danishgreencardimport from "@/pages/danishgreencardimport";
const Denmarkdanishgreencard = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/denmarked.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
        
        </div>
      </div>
      <div className="mt-10 w-full px-5 md:w-3/4 md:ml-20 lg:ml-32 text-center md:text-left text-3xl font-bold text-[#011473] drop-shadow-md">
  Denmark: Your Gateway to a New Beginning with Visa World Immigration
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-8">
        {/* Left Section: Image */}

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/Denmarks.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-8 lg:w-1/2">
  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Educational Qualifications:</a> Possess a higher education degree equivalent to a Danish Bachelor's degree.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Language Proficiency: </a>Demonstrate fluency in Danish, Swedish, Norwegian, English, or German.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Professional Experience:</a> Have relevant work experience in your area of expertise.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Age Criteria:</a> Younger candidates are given preference.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold">Adaptability:</a> Show the ability to integrate into the Danish workforce and society.
    </span>
  </div>
</div>

      </div>
      <div className="px-5 md:px-20">
  <p className="mb-5 w-full text-center md:ml-32 md:w-2/3 md:text-left text-2xl font-bold text-[#011473]">
    Why Choose Visa World for Your Danish Green Card Application?
  </p>
  <div className="mx-auto mb-20 space-y-6 md:ml-32 md:w-2/3 text-left md:text-left">
    <div className="flex items-center">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold">Expert Guidance:</a> Visa World provides specialized support for Danish Green Card applications.
      </span>
    </div>

    <div className="flex items-center">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold">Personalized Assistance:</a> Tailored advice to meet your unique immigration needs.
      </span>
    </div>

    <div className="flex items-center">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold"> Experienced Consultants:</a> Skilled professionals ensure a smooth and efficient application process.
      </span>
    </div>

    <div className="flex items-center">
      <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-blue-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold"> Achieve Your Goals:</a> Helping you realize your dream of living and working in Denmark.
      </span>
    </div>
  </div>
</div>

    

      <Danishgreencardimport />
      <div className="flex w-full flex-col items-center text-black justify-center py-20">
  {isOpen && (
    <div className="mb-6 w-3/4 items-center justify-center rounded-md bg-gray-100 p-4 text-lg shadow-md">
      <p>
        <br />
        - <strong>What is the Danish Green Card?</strong>  
        The Danish Green Card is a residence permit enabling you to live and work in Denmark.  
        <br />
        - <strong>Opportunity for Skilled Professionals</strong>  
        It targets highly skilled individuals who can contribute to Denmark's economic growth.  
        <br />
        - <strong>Benefits of a Danish Green Card</strong>  
        Enjoy living in one of the world's happiest and most prosperous nations while building a rewarding career.  
        <br />
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="flex md:w-1/2 w-2/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
  >
    Denmark Immigration – Danish Green Card Details
    <svg
      className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>


     
      <Contacts />
    </>
  );
};

export default Denmarkdanishgreencard;
